import entertainmentImage from "../assets/entertainment.webp";
import iconCustomer from "../assets/customer.png";
import iconSecurity from "../assets/security.png";
import iconBackend from "../assets/backend.png";
import iconAnalytics from "../assets/data.png";
import partyImage from "../assets/enter.webp";
import checkIcon from "../assets/check-icon.png";
import icon1 from "../assets/feature1.png";
import icon2 from "../assets/feature2.png";
import icon3 from "../assets/feature3.png";
import checkIIcon from "../assets/check-purple.png";
import { motion } from "framer-motion";
import { useEffect, useRef } from "react";

import { Helmet } from "react-helmet-async";

export default function EntertainmentSection() {

  // const [openDropdown, setOpenDropdown] = useState(null);
  const navRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (navRef.current && !navRef.current.contains(event.target)) {
        // setOpenDropdown(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const featuresData = [
    {
      icon: icon1,
      title: "Streamlined booking experience",
      description:
        "Lentera's ticket booking system is a prime example of their commitment to offering cutting edge digital solutions that improve consumer experiences.",
      points: ["Intuitive User Interface", "Secure Transaction Process"],
    },
    {
      icon: icon2,
      title: "Enhanced security & Reliability",
      description:
        "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
      points: ["Robust Backend Infrastructure", "Secure Payment Methods"],
    },
    {
      icon: icon3,
      title: "Enhanced customer service & Analytics",
      description:
        "Transparent, data-driven feedback promotes accountability and continuous improvement through objective decision-making.",
      points: ["Data-Driven Analytics", "Enhanced Customer Service"],
    },
  ];

  const features = [
    "The site includes an easy-to-use design that makes buying tickets simple and available to all users.",
    "By ensuring that transactions are reliable and safe, integrated secure payment gateways let users feel more confident.",
    "Backend infrastructure maintains stability and dependability due to its high traffic volume handling capacity.",
    "The interface supports multi-device responsiveness, providing a smooth experience on desktop and mobile.",
    "Smart analytics help track user behavior and optimize ticket sales in real-time.",
  ];

  return (
    <>
      <Helmet>
        <title>Entertainment Software & Ticketing Solutions | LENTERA Digital Platforms</title>
        <meta name="description" content=" Transform the live event experience with LENTERA’s innovative entertainment software and ticket booking system. Enjoy seamless navigation, secure payments, multi-device access and data-driven insights to enhance engagement and customer satisfaction." />
        <meta name="keywords" content="LENTERA entertainment platform, personalized entertainment recommendations, backend integration for events." />
      </Helmet>

      <section className="w-full min-h-[] bg-black text-white font-poppins overflow-hidden relative">
        <div className="w-full min-h-screen flex flex-col-reverse lg:flex-row items-center justify-between px-6 lg:px-20 relative z-10">

          {/* Left: Text + gradient blur background */}
          <div className="w-full lg:w-1/2 flex flex-col justify-center text-center lg:text-left relative z-10 py-12">
            {/* Blurred gradient background layer */}
            <div className="absolute inset-0 bg-gradient-to-r from-[#EF3BF2] via-[#7B41E6] to-black blur-3xl opacity-60 z-0" />

            <motion.div
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8, ease: "easeOut" }}
              viewport={{ once: true }}
              className="relative z-10"
            >
              <p className="text-sm font-medium text-white/70 uppercase tracking-wide mb-4">
                Entertainment
              </p>
              <h1 className="text-[32px] sm:text-[40px] lg:text-[48px] font-bold leading-tight mb-6">
                Excitement meets <br /> unforgettable experiences
              </h1>
              <p className="text-base sm:text-lg text-[#D4D4D8] max-w-xl mx-auto lg:mx-0">
                Discover a world where every moment is filled with excitement and unforgettable experiences that inspire, entertain and connect.
              </p>
            </motion.div>
          </div>

          {/* Right: Image with animation */}

          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
            viewport={{ once: true }}
            className="w-full lg:w-1/2 flex justify-center lg:justify-end"
          >
            <div className="relative w-[100px] h-[300px] sm:h-[400px] sm:w-[400px] md:h-[400px] lg:h-auto lg:min-h-screen lg:absolute lg:top-0 lg:bottom-0 lg:right-0 lg:w-1/2">
              <img
                src={entertainmentImage}
                alt="Entertainment VR"
                className="absolute top-0 right-0 bottom-0 w-full h-full object-cover"
              />
            </div>
          </motion.div>
        </div>

        <section className="w-full bg-[#121212] text-white font-poppins px-6 lg:px-20 py-12">
          <div className="max-w-screen-xl mx-auto flex flex-col lg:flex-row justify-between items-start lg:items-stretch gap-12 lg:gap-0 relative">

            {/* Left Block */}
            <motion.div
              initial={{ opacity: 0, x: -40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 pr-0 lg:pr-10"
            >
              <h2 className="text-xl sm:text-2xl font-semibold mb-4">Overview</h2>
              <p className="text-[#D4D4D8] text-base leading-relaxed">
                Lentera introduces a smart, user-friendly ticketing system designed to transform the concert experience.
                This innovative platform streamlines access to live events, reflecting LENTERA’s commitment to digital
                innovation and creative solutions.
              </p>
            </motion.div>

            {/* Divider */}
            <motion.div
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              transition={{ delay: 0.5, duration: 0.5 }}
              viewport={{ once: true }}
              className="hidden lg:block w-px bg-[#D4D4D8]/30 mx-10"
            />

            {/* Right Block */}
            <motion.div
              initial={{ opacity: 0, x: 40 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 lg:pl-10"
            >
              <h2 className="text-xl sm:text-2xl font-semibold mb-4">
                Our impact on entertainment <br className="hidden sm:block" />
                platforms
              </h2>
              <p className="text-[#D4D4D8] text-base leading-relaxed">
                This entertainment software offers an all-in-one platform for games, movies, music and live streams,
                with smooth navigation and personalized recommendations to boost engagement.
              </p>
            </motion.div>
          </div>
        </section>

        <section className="w-full bg-black text-white px-4 lg:px-24 py-20 font-poppins">
          <div className="max-w-screen-xl mx-auto">
            {/* Top Heading */}
            <motion.div
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="flex flex-col lg:flex-row justify-between items-start mb-12"
            >
              <h2 className="text-3xl sm:text-4xl font-bold leading-tight max-w-md">
                Next-Level <br /> advantages await
              </h2>
              <p className="text-[#D4D4D8] text-base mt-4 lg:mt-0 max-w-lg">
                Experience smarter solutions, seamless performance and impactful results — because with LENTERA, next-level advantages are just the beginning.
              </p>
            </motion.div>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[iconCustomer, iconSecurity, iconBackend, iconAnalytics].map((icon, index) => {
                const titles = [
                  "Customer centric approach",
                  "User experience & security",
                  "Backend flexibility",
                  "Advanced analytics"
                ];
                const descs = [
                  "Lentera’s ticket booking system delivers superior digital solutions with a user-first design and a seamless, easy-to-use interface.",
                  "With real-time seat availability and secure payments, users can easily select seats, navigate the platform and book with confidence and ease.",
                  "Easily integrate with various APIs, databases and infrastructure tools for faster and more adaptable system operations.",
                  "Gain powerful insights into customer behavior and operational efficiency to make informed, data-driven decisions."
                ];

                return (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: index * 0.1 }}
                    viewport={{ once: true }}
                    className="bg-[#1E1E1E] rounded-3xl p-8"
                  >
                    <img src={icon} alt={titles[index]} className="w-20 h-20 mb-6 object-contain" />
                    <h3 className="text-lg font-semibold mb-3">{titles[index]}</h3>
                    <p className="text-[#D4D4D8] text-sm leading-relaxed">{descs[index]}</p>
                  </motion.div>
                );
              })}
            </div>
          </div>
        </section>

        {/* Innovative Ticket Booking Section */}
        <div className="bg-black text-white font-poppins px-6 md:px-20 py-20">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h1 className="text-4xl md:text-5xl font-bold mb-4">Innovative ticket booking system</h1>
            <p className="text-lg md:text-xl text-gray-300 max-w-3xl mx-auto">
              Experience the future of live events with our Innovative Ticket Booking System — where convenience, security and seamless access come together like never before.
            </p>
          </motion.div>

          <div className="flex flex-col lg:flex-row items-center justify-between gap-12">
            {/* Image */}
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2 flex justify-center lg:justify-end"
            >
              <img src={partyImage} alt="Party Event" className="w-full max-w-md lg:max-w-[500px] rounded-3xl shadow-2xl object-cover" />
            </motion.div>

            {/* Features List */}
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }}
              className="w-full lg:w-1/2"
            >
              <div className="mb-6">
                <span className="text-gray-400 font-semibold text-sm uppercase tracking-wider">Features</span>
                <div className="border-t border-dashed border-gray-500 w-44 mt-1" />
              </div>

              <div className="space-y-6">
                {features.map((text, i) => (
                  <motion.div
                    key={i}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.4, delay: i * 0.1 }}
                    viewport={{ once: true }}
                    className="flex items-start bg-gradient-to-r from-[#2c026c] to-[#18003a] rounded-2xl px-6 py-5"
                  >
                    <img src={checkIcon} alt="Check" className="w-6 h-6 mt-1 mr-4 shrink-0" />
                    <p className="text-base md:text-lg leading-relaxed text-white">{text}</p>
                  </motion.div>
                ))}
              </div>
            </motion.div>
          </div>
        </div>

        {/* Key Features Section */}
        <section className="bg-black text-white font-poppins px-6 md:px-20 py-20">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="text-4xl md:text-5xl font-bold mb-4">Key features</h2>
            <p className="text-lg text-gray-300">Discover the game-changing key features that set you apart!</p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {featuresData.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 50 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                viewport={{ once: true }}
                className="bg-gradient-to-b from-[#000000] to-[#402374] rounded-3xl p-8 text-center shadow-lg flex flex-col justify-between"
              >
                <img src={feature.icon} alt="Feature Icon" className="w-16 h-16 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-4">{feature.title}</h3>
                <p className="text-gray-300 mb-6">{feature.description}</p>
                <div className="border border-[#5F4396] border-opacity-40 rounded-xl px-4 py-4 text-left space-y-3 bg-[#5F4396] bg-opacity-10">
                  {feature.points.map((point, i) => (
                    <div key={i} className="flex items-center gap-3">
                      <img src={checkIIcon} alt="Check" className="w-5 h-5" />
                      <span>{point}</span>
                    </div>
                  ))}
                </div>
              </motion.div>
            ))}
          </div>
        </section>
      </section>
    </>
  );
}